//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import Family from './list';
import FamilyEdit from './edit';

export const FilterFamilys = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[2] !== "familys") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterFamilys.Provider value={{ filter, setFilter }}>
      <Route path="/premixlabel/product_family" exact component={Family} isPrivate/>
      <Route path="/premixlabel/product_family/edit/:id" exact component={FamilyEdit} isPrivate/>
    </FilterFamilys.Provider>
  )
}